import { initialState as authInitialState } from '../data/initialState.auth.data';
import { initialState as customerInitialState } from '../data/initialState.customer.data';
import { initialState as commonInitialState } from '../data/initialState.common.data';
import { initialState as layoutInitialState } from '../data/initialState.layout.data';
import { initialState as serviceLevelInitialState } from '../data/setup/initialState.serviceLevel.data';
import { initialState as erpProductsInitialState } from '../data/setup/initialState.erpProductSearch.data';
import { initialState as warrantyInitialState } from '../data/setup/initialState.warranty.data';
import { initialState as eTrackSettingsInitialState } from '../data/setup/eTrackSettings/initialState.eTrackSettings.data';
import { initialState as priceClassesInitialState } from '../data/setup/priceBook/initialState.priceClass.data';
import { initialState as priceSheetInitialState } from '../data/setup/priceBook/initialState.priceSheet.data';
import { initialState as billClassInitialState } from '../data/setup/priceBook/initialState.billClass.data';
import { initialState as oosBillSetsInitialState } from '../data/setup/oosBillSets/initialState.oosBillSets.data';
import { initialState as contractInitialState } from '../data/entitlement/contracts/initialState.contracts.data';
import { initialState as addNewContractInitialState } from '../data/entitlement/contracts/addContracts/initialState.addcontracts.data';
import { initialState as contractNotesInitialState } from '../data/entitlement/contracts/notes/initialState.notes.data';
import { initialState as erpSalesOrderInitialState } from '../data/entitlement/erpSalesOrder/initialState.erpSalesOrder.data';
import { initialState as sityActivityInitialState } from '../data/entitlement/siteActivity/initialState.siteActivity.data';
import { initialState as entitlementHistoryInitialState } from '../data/entitlement/entitlementHistory/initialState.entitlementHistory.data';
import { initialState as outOfScopeCasesInitialState } from '../data/entitlement/outOfScopeCases/initialState.outOfScopeCases.data';
import { initialState as salesMappingInitialState } from '../data/entitlement/contracts/salesMapping/initialState.salesMapping.data';
import { initialState as entitlementsShippingInfoInitialState } from '../data/entitlement/entitlements/entitlementsShippingInfo/initialState.entitlementsShippingInfo.data';
import { initialState as entitlementDetailsInitialState } from '../data/entitlement/sites/entitlementDetails/initialState.entitlementDetails.data';
import { initialState as erpSearchAndRetrieveSalesOrderState } from '../data/entitlement/erpSalesOrder/initialState.erpSearchAndRetrieveSalesOrder.data';
import { initialState as contractHisoryInitialState } from '../data/entitlement/contracts/contracHistory/initialState.contractHistory.data';
import { initialState as entitlementsSiteActivityInitialState } from '../data/entitlement/entitlements/entitlementsSiteActivity/initialState.entitlementsSiteActivity.data';
import { initialState as siteActivityDetailInitialState } from '../data/entitlement/sites/siteActivityDetail/initialState.siteActivityDetail.data';
import { initialState as entitlementContractHistoryInitialState } from '../data/entitlement/entitlements/entitlementContractHistory/initialState.entitlementContractHistory.data';
import { initialState as erpSalesOrderItemsInitialState } from '../data/entitlement/erpSalesOrderItems/initialState.erpSalesOrderItems.data';
import { initialState as eTrackQuoteinitialState } from '../data/eTrack/initialState.eTrack.data';
import { initialState as adminScreenRoleInitialState } from '../data/userSetup/adminScreenRole/initialState.adminScreenRole.data';
import { initialState as contractOutOfScopeInitialState } from '../data/entitlement/contracts/contractOutOfScope/initialState.contractOutOfScope.data';
import { initialState as entitlementBillingActivityState } from '../data/entitlement/entitlements/entilementBillingActivity/initialState.entitlementBillingActivity.data';
import { initialState as copyContractState } from '../data/entitlement/contracts/copyContract/initialState.copycontract.data';
import { initialState as relatedContractsState } from '../data/entitlement/contracts/relatedContracts/initialState.relatedcontracts.data';
import { initialState as auditTrailState } from '../data/entitlement/contracts/auditTrail/initialState.auditTrail.data';
import { initialState as eTrackUserMcnMappingInitialState } from '../data/userSetup/eTRACKUserMCNMapping/initialState.eTrackUserMcnMapping.data';

export const IS_DEV_MODE = process.env.REACT_APP_ENV === 'development';
export const PORT = IS_DEV_MODE ? 3000 : 8080;
export const API_MAX_RETRY_COUNT = 1;
export const ENABLE_API_ERROR_CONSOLE_LOGS = true;
export const GRID_SPACING = 3;
export const DRAWER_WIDTH = 260;
export const APP_DRAWER_WIDTH = 320;

export const THEME_CONFIG = {
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  buttonBorderRadius: 5,
};

export const ENV_VARS = {
  REACT_APP_API_GATEWAY_URL: 'REACT_APP_API_GATEWAY_URL',
  REACT_APP_API_GATEWAY_SUBSCRIPTION_KEY:
    'REACT_APP_API_GATEWAY_SUBSCRIPTION_KEY',
  REACT_APP_OPEN_SMART_SHEET_URL: 'REACT_APP_OPEN_SMART_SHEET_URL',
  REACT_APP_EXTERNAL_USER_LOGOUT_URL: 'REACT_APP_EXTERNAL_USER_LOGOUT_URL',
};

export const findReverseProxyURL = () => {
  let regex = /f5-w-[^$]*\$\$/;
  let match = window.location.href.match(regex);
  return match ? match[0] : null;
}

export const INITIAL_STATE = {
  auth: authInitialState,
  common: commonInitialState,
  customer: customerInitialState,
  layout: layoutInitialState,
  serviceLevel: serviceLevelInitialState,
  erpProductSearch: erpProductsInitialState,
  warranty: warrantyInitialState,
  eTrackSettings: eTrackSettingsInitialState,
  priceClass: priceClassesInitialState,
  priceSheet: priceSheetInitialState,
  billClass: billClassInitialState,
  oosBillSets: oosBillSetsInitialState,
  contracts: contractInitialState,
  addNewContract: addNewContractInitialState,
  contractNotes: contractNotesInitialState,
  erpSalesOrder: erpSalesOrderInitialState,
  siteActivity: sityActivityInitialState,
  entitlementHistory: entitlementHistoryInitialState,
  outOfScopeCases: outOfScopeCasesInitialState,
  salesMapping: salesMappingInitialState,
  entitlementsShippingInfo: entitlementsShippingInfoInitialState,
  entitlementDetails: entitlementDetailsInitialState,
  erpSearchAndRetrieveSalesOrder: erpSearchAndRetrieveSalesOrderState,
  contractHistory: contractHisoryInitialState,
  entitlementsSiteActivity: entitlementsSiteActivityInitialState,
  siteActivityDetail: siteActivityDetailInitialState,
  entitlementContractHistory: entitlementContractHistoryInitialState,
  erpSalesOrderItems: erpSalesOrderItemsInitialState,
  eTrackQuote: eTrackQuoteinitialState,
  AdminScreenRole: adminScreenRoleInitialState,
  contractOutOfScope: contractOutOfScopeInitialState,
  entitlementBillingActivity: entitlementBillingActivityState,
  copyContract : copyContractState,
  relatedContracts: relatedContractsState,
  auditTrail: auditTrailState,
  ETrackUserMCNMapping: eTrackUserMcnMappingInitialState,
};
